<template>
    <div ref="dom"
        class="charts chart-bar"></div>
</template>

<script>
import * as echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { numberToFixed } from '@/components/number-input/display-format';
echarts.registerTheme('tdTheme', tdTheme);
export default {
    name: 'MonthlySaleBar',
    props: {
        value: Object,
        text: String,
        subtext: String
    },
    data() {
        return {
            dom: null
        };
    },
    methods: {
        resize() {
            this.dom.resize();
        }
    },
    mounted() {
        // this.init();
    },
    beforeDestroy() {
        off(window, 'resize', this.resize);
    },
    methods: {
        init() {
            this.$nextTick(() => {
                let xAxisData = Object.keys(this.value);
                let seriesData = Object.values(this.value);
                let option = {
                    title: {
                        text: this.text,
                        subtext: this.subtext,
                        x: 'center'
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value, index) {
                                return value / 10000 + '万';
                            }
                        }
                    },
                    series: [{
                        data: seriesData,
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: "top",
                                formatter: function (params) {
                                    let w = params.value / 10000;
                                    if (w > 1) {
                                        return numberToFixed(w, 2) + "万";
                                    }
                                    else {
                                        return "小于1万";
                                    }
                                }
                            }
                        }
                    }]
                };
                this.dom = echarts.init(this.$refs.dom, 'tdTheme');
                this.dom.setOption(option);
                on(window, 'resize', this.resize);
            });
        }
    }
};
</script>
